import React from 'react';

export const SeccionAceptacionDocs = ({objetoDinamico,
                                    setDocumento }) => {
        return <section className="bg-slate-900 rounded-2xl p-8 relative overflow-hidden shadow-xl">
                    <div className="relative z-10">
                      
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {[
                          { id: 'estatutos', label: 'Testimonio y Estatutos de la Unión de las Asambleas de Dios', status: objetoDinamico?.estatutos },
                          { id: 'doctrina', label: 'Doctrinas Fundamentales de la Unión de las Asambleas de Dios', status: objetoDinamico?.doctrina },
                          { id: 'compromiso', label: 'Compromiso Ministerial de la Unión de las Asambleas de Dios', status: objetoDinamico?.compromiso }
                        ].map((doc) => (
                          <div 
                            key={doc.id}
                            onClick={() => setDocumento(doc.id)}
                            className={`cursor-pointer p-6 rounded-2xl transition-all border-2 flex flex-col items-center text-center gap-4
                              ${doc.status === true 
                                ? 'bg-blue-600/20 border-blue-500/50' 
                                : 'bg-white/5 border-deep-orange-100 hover:border-blue-400'}`}
                          >
                            <div 
                              className="text-[13px] font-bold uppercase tracking-wide leading-normal"
                              style={{ color: 'black', opacity: 1 }}
                            >
                              {doc.label}
                            </div>
                            
                            <div className="mt-2">
                              {doc.status === true ? (
                                <span className="bg-blue-600 text-white text-[10px] font-black uppercase px-3 py-1 rounded-full">
                                  Aceptado
                                </span>
                              ) : (
                                <span className="bg-red-600 text-white text-[10px] font-black uppercase px-3 py-1 rounded-full animate-pulse">
                                  Pendiente
                                </span>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </section>

};